import { useState } from "react"
import { useOutletContext } from "react-router-dom"
import { BillingLogs, LoanOfficer } from "../../../../types"
import { useFetchOrgSystemUsageQuery } from "../../../../redux/queries"
import If from "../../if"
import { ListSkeleton } from "../../skeletons"
import { InvoicesTable } from "../../billing-table"
import { CustomPagination } from "../../pagination"

interface OutletContext {
  profile: LoanOfficer
}
let month = ""
const BankBilling = () => {
  const { profile } = useOutletContext<OutletContext>()

  const [currentPageInvoices, setCurrentPageInvoices] = useState<BillingLogs>(
    []
  )

  // Fetch system usage for each org
  const {
    data: systemUsage = [],
    isFetching: isFetchingUsage,
    isError: isErrorUsage
  } = useFetchOrgSystemUsageQuery(
    { orgId: profile?.org_id, month },
    { skip: !profile?.org_id }
  )

  return (
    <div className="p-6">
      <h2 className="font-bold text-xl">Bank Billing</h2>
      {
        // Error state for data
        isErrorUsage && <p>Failed to load data.</p>
      }
      <If
        condition={(isFetchingUsage || !profile?.org_id) && !isErrorUsage}
        then={<ListSkeleton containerClassName="rounded-lg overflow-hidden" />}
        else={
          <>
            <InvoicesTable
              orgId={profile?.org_id}
              systemUsage={currentPageInvoices}
              invoicePath="account/billing"
            />
            <CustomPagination<BillingLogs>
              items={systemUsage}
              updateDisplayedItems={setCurrentPageInvoices}
            />
          </>
        }
      />
    </div>
  )
}

export default BankBilling
